// Vários arquivos na calculadora: a partir do 2º arquivo importado, cada um vira
// um item com o PRÓPRIO cálculo completo (tempo, filamentos, extras, taxas,
// margem/preço, impressora). Cada item: { id, calculo, arquivoFatiado,
// fotoBase64, coresDetectadas, resumoImportacao } — `calculo` é a foto do
// estado do hook (useCalculoProduto.capturarCalculo).

export const nomeDoArquivo = (fileName) => String(fileName || "").replace(/\.(3mf|gcode)$/i, "").trim();

export const nomeDoItem = (item) =>
  item.calculo.nome?.trim() || nomeDoArquivo(item.arquivoFatiado?.fileName) || "Arquivo";

export const unidadesDoItem = (calculo) => Math.max(1, parseInt(calculo.unidades) || 1);

// Cálculo de um item novo: herda a configuração do cálculo de partida
// (impressora, taxas, margem, extras, mão de obra) como ponto de partida, mas
// nasce sem filamentos e com o tempo do próprio arquivo. Cada item edita o seu.
export function calculoDoNovoItem(base, { nome, horas }) {
  return {
    ...base, nome, unidades: "1", filamentosCalc: [],
    horas: Number.isFinite(horas) ? String(horas) : "",
  };
}

// Depois de remover um ou mais arquivos: quem fica ativo (o ativo continua se não
// saiu; senão o mais próximo à esquerda, ou o primeiro) e se o lote acabou (menos de 2).
export function depoisDeRemover(itens, idsRemovidos, ativoId) {
  const ids = [].concat(idsRemovidos);
  const restantes = itens.filter(i => !ids.includes(i.id));
  let novoAtivoId = ativoId;
  if (ids.includes(ativoId)) {
    const anterior = itens.slice(0, itens.findIndex(i => i.id === ativoId)).reverse().find(i => !ids.includes(i.id));
    novoAtivoId = (anterior ?? restantes[0])?.id ?? null;
  }
  return { restantes, ativoId: novoAtivoId, encerrarLote: restantes.length < 2 };
}
